/* global axios */
/* eslint-disable class-methods-use-this */
import ApiClient from './ApiClient';

class LicenseAPI extends ApiClient {
  constructor() {
    super('license', { accountScoped: false });
  }

  validate() {
    return axios.get('/api/v1/license/validate');
  }

  upgradePlan(planId) {
    return axios.post('/api/v1/license/upgrade', { plan_id: planId });
  }

  fetchPlans() {
    return axios.get('/api/v1/plans');
  }
}

export default new LicenseAPI();
